import { render, staticRenderFns } from "./CoralsolLocalidadeForm.vue?vue&type=template&id=466e52ba&scoped=true&"
import script from "./CoralsolLocalidadeForm.vue?vue&type=script&lang=js&"
export * from "./CoralsolLocalidadeForm.vue?vue&type=script&lang=js&"
import style0 from "./CoralsolLocalidadeForm.vue?vue&type=style&index=0&id=466e52ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466e52ba",
  null
  
)

export default component.exports